import { mockLoanData } from '@frontend/pricing-search';
import Session, { IS_DEBUG, JWT_TOKEN } from '../services/Session';
import api from '../utils/api';
import { callDebugRestProxy } from '../services/debugRestProxyServices';

class QualificationService {
  // This is only used in Standalone mode...

  async getRates(loanInfo) {
    const payload = loanInfo !== undefined ? loanInfo : mockLoanData;
    if (Session.get(IS_DEBUG)) {
      return callDebugRestProxy({
        key: 'rates',
        payload,
      });
    }

    const Rates = await api.getRates({
      body: JSON.stringify(payload),
      customToken: { value: Session.get(JWT_TOKEN) },
      tokenType: 'Bearer',
    });
    return Rates;
  }
}

export default new QualificationService();
